module.exports = __webpack_public_path__ + "static/btn_compass-25e7052b9f056cbaf54b0bd2e3d716f4.png";